const filterAvailable = <T extends { name: string }>(
  mapped: T[],
  allowed: string[],
  // eslint-disable-next-line no-unused-vars
  id: (value: T) => string,
): T[] => {
  return mapped
    .filter((value) => value)
    .filter((value, index, all) => all.findIndex((it) => id(it) === id(value)) === index)
    .filter((value) => allowed.length === 0 || allowed.includes(id(value)))
    .sort((a, b) => a.name.localeCompare(b.name));
};

export default filterAvailable;
